import styled from 'styled-components';
import { NewStyleColor, BaseStyledComponentProps } from '../../utils/styles-constants';
import { HeaderBlockContainer, HeaderBlockTitle } from '../HeaderBlock/styles';

const StyledAccordion = styled('div')`
	display: flex;
	flex-flow: column nowrap;
	margin: 4px 0;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.strongColor};

	@media print {
		color: #000;
	}
`;

const AccordionHeader = styled(HeaderBlockContainer)`
	padding-right: 15px;
`;

const AccordionTitle = HeaderBlockTitle;

interface ToggleButtonProps {
	isOpened: boolean;
}

const ToggleButton = styled('div')`
	& > svg {
		width: 18px;
		height: 18px;
		fill: ${NewStyleColor.Grey600};
	}

	${(props: ToggleButtonProps) => props.isOpened ? '' : `transform: rotate(-90deg);`}
`;

export { StyledAccordion, AccordionHeader, AccordionTitle, ToggleButton };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Accordion/styles.ts